(function () {
  const GOAL_SELECTOR = '.tl-custom-cart-goal-container';

  const CART_DRAWER_SELECTORS = [
    'cart-drawer',
    '#CartDrawer',
    '.cart-drawer',
    '.drawer--cart',
    '[data-cart-drawer]'
  ];

  function getCartDrawers() {
    const drawers = [];

    CART_DRAWER_SELECTORS.forEach(selector => {
      document.querySelectorAll(selector).forEach(drawer => {
        if (!drawers.includes(drawer)) {
          drawers.push(drawer);
        }
      });
    });

    return drawers;
  }

  function removeDuplicateGoalContainers() {
    const drawers = getCartDrawers();

    drawers.forEach(drawer => {
      const containers = drawer.querySelectorAll(GOAL_SELECTOR);

      // Không có hoặc chỉ có 1 thì không cần xử lý
      if (containers.length <= 1) {
        return;
      }

      // Ưu tiên giữ element đang hiển thị
      let keep = Array.from(containers).find(el => {
        const style = window.getComputedStyle(el);

        return (
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          el.offsetWidth > 0 &&
          el.offsetHeight > 0
        );
      });

      // Nếu không tìm được element visible thì giữ element đầu tiên
      if (!keep) {
        keep = containers[0];
      }

      // Xóa tất cả bản duplicate
      containers.forEach(container => {
        if (container !== keep) {
          container.remove();
        }
      });
    });
  }

  let scheduled = false;

  function scheduleCheck() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      removeDuplicateGoalContainers();
    });
  }

  // Chạy lần đầu
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCheck);
  } else {
    scheduleCheck();
  }

  // Theo dõi Shopify Cart Drawer render/re-render bằng AJAX
  const observer = new MutationObserver(() => {
    scheduleCheck();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
